import React, { Component } from "react";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import crStyles from "../../../customerReservation/crStyles";
import styles from "../OrderDetailsNewVersion.module.scss";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SpecsRow from "../SpecsRow";
import { withTranslation } from "react-i18next";
import { formatEUPriceValue } from "../../../../utils/FormatPrice";

class FinanceAndLeaseBreakDownHercules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandFinanceQuote: false,
      expandCharging: false,
      expandAccessories: false,
      itemsNotIncludedOnQuoteExpansion: false,
      expandItemsNotIncludedAccessories: false,
      expandItemsNotIncludedCharging: false,
      expandProtectionPlans: false,
    };
    this.distanceUnit =
      this.props.localizedInfo && this.props.localizedInfo.defaultDistanceUnit
        ? "/".concat(this.props.localizedInfo.defaultDistanceUnit)
        : "";
  }

  expandProtectionPlans() {
    this.setState((prevState) => ({
      expandProtectionPlans: !prevState.expandProtectionPlans,
    }));
  }

  expandItemsNotIncludedCharging() {
    this.setState((prevState) => ({
      expandItemsNotIncludedCharging: !prevState.expandItemsNotIncludedCharging,
    }));
  }

  expandItemsNotIncludedAccessories() {
    this.setState((prevState) => ({
      expandItemsNotIncludedAccessories:
        !prevState.expandItemsNotIncludedAccessories,
    }));
  }

  expandAccessories() {
    this.setState((prevState) => ({
      expandAccessories: !prevState.expandAccessories,
    }));
  }

  expandCharging() {
    this.setState((prevState) => ({
      expandCharging: !prevState.expandCharging,
    }));
  }

  expandFinanceQuote() {
    this.setState((prevState) => ({
      expandFinanceQuote: !prevState.expandFinanceQuote,
    }));
  }

  itemsNotIncludedOnQuoteExpansion() {
    this.setState((prevState) => ({
      itemsNotIncludedOnQuoteExpansion:
        !prevState.itemsNotIncludedOnQuoteExpansion,
    }));
  }

  formatPriceValue = (value) => {
    const defaultCurrency = this.props.defaultCurrency;
    return formatEUPriceValue(value, defaultCurrency);
  };

  render() {
    const financeDataQuote = this.props.customerReservation.financeDataQuote;
    const pricingStack = this.props.customerReservation.pricingStack;

    return (
      <div>
        <StyledBasicExpansionPanel
          expanded={this.state.expandFinanceQuote}
          onChange={() => this.expandFinanceQuote()}
          data-testid="financeExpansionPanel"
        >
          <StyledBasicExpansionPanelSummary
            style={crStyles.orderDetailsExpansion}
          >
            <div className={styles.headerBar}>
              <div className={styles.header}>
                {this.props.t("FinanceBreakDownHercules.title")}
              </div>
              <div>
                {this.state.expandFinanceQuote ? (
                  <ExpandLessIcon data-testid="lessFinanceQuote" />
                ) : (
                  <ExpandMoreIcon data-testid="moreFinanceQuote" />
                )}
              </div>
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>

          {financeDataQuote ? (
            <div>
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.monthlyPayment"
                )}
                price={this.formatPriceValue(financeDataQuote.monthlyPayment)}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.totalCredit"
                )}
                price={this.formatPriceValue(
                  financeDataQuote.totalAmountFinancedStandard
                )}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.numberOfPayments"
                )}
                price={
                  financeDataQuote.numberOfPayments
                    ? financeDataQuote.numberOfPayments
                    : "0"
                }
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />

              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.optionalFinalPayment"
                )}
                price={this.formatPriceValue(
                  financeDataQuote.optionalFinalPayment
                )}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.depositAmount"
                )}
                price={this.formatPriceValue(financeDataQuote.deposit)}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
                dataTestId="depositAmount"
              />

              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.depositAllowance"
                )}
                price={this.formatPriceValue(financeDataQuote.depositAllowance)}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
                dataTestId="depositAllowance"
              />

              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.totalAmountPayable"
                )}
                price={this.formatPriceValue(
                  financeDataQuote.totalAmountPayable
                )}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.fixedInterestRate"
                )}
                price={
                  financeDataQuote.fixedInterestRate
                    ? financeDataQuote.fixedInterestRate
                    : "0.00"
                }
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t("FinanceBreakDownHercules.apr")}
                price={financeDataQuote.apr ? financeDataQuote.apr : "0.00"}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.annualMileage"
                )}
                price={
                  financeDataQuote.annualMileage
                    ? financeDataQuote.annualMileage
                    : "--"
                }
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.sellingPrice"
                )}
                price={this.formatPriceValue(financeDataQuote.sellingPrice)}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />

              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.tradeInValue"
                )}
                price={this.formatPriceValue(pricingStack.trueNetValue)}
                style={styles.darkCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
              <SpecsRow
                priceDetails={this.props.t(
                  "FinanceBreakDownHercules.reservationDeposit"
                )}
                price={this.formatPriceValue(pricingStack.orderDepositPrice)}
                style={styles.lightCaseSensitiveHeader}
                rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText}`}
              />
            </div>
          ) : null}
        </StyledBasicExpansionPanel>
      </div>
    );
  }
}

export default withTranslation("emp")(FinanceAndLeaseBreakDownHercules);
